"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MomentDatePipe = void 0;
const common_1 = require("@angular/common");
const moment = require("moment-timezone");
/**
* A moment timezone pipe to support parsing based on time zone abbreviations
* covers all cases of offset variation due to daylight saving.
*
* Same API as DatePipe with additional timezone abbreviation support
* Official date pipe dropped support for abbreviations names from Angular V5
*/
class MomentDatePipe {
    constructor(datePipe) {
        this.datePipe = datePipe;
    }
    transform(value, format, timezone) {
        const timezoneOffset = moment.tz(value, timezone).format('Z');
        return this.datePipe.transform(value, format, timezoneOffset);
    }
}
exports.MomentDatePipe = MomentDatePipe;
//# sourceMappingURL=momentDate.pipe.js.map